import { Validator, nlLang as nl } from "@upjs/facile-validator";

export const form = {
  init: () => {
    const formEls = document.querySelectorAll("form.wheelform");
    const requiredFormGroups = document.querySelectorAll(".form-group--required");

    const nlMesssages = { ...nl };

    nlMesssages["accepted"] = "Je bent niet akkoord gegaan met dit veld";
    nlMesssages["required"] = "Dit veld is niet ingevuld";
    nlMesssages["email"] = "Het ingevulde e-mailadres is onjuist. Een geldig e-mailadres is bijvoorbeeld naam@domein.nl .";

    formEls.forEach((el) => {
      const v = new Validator(el, {
        lang: nlMesssages,
        onFieldChangeValidation: true,
        xRules: {
          dutchPhone: {
            value:
              /^(?:\+31|0)(?:(6[\s-]?[1-9]\d{7})|(?:[1-9]\d{1,2}[\s-]?\d{6,7}))$/,
            errorMessage: "Dit is een ongeldig Nederlands telefoonnummer. Een geldig nummer is bijvoorbeeld 0612345678.",
          },
          dutchPostalCode: {
            value: /^[1-9][0-9]{3}\s?[A-Za-z]{2}$/,
            errorMessage: "De ingevulde postcode is onjuist. Een geldige postcode start met vier cijfers en eindigt met twee letters, bijvoorbeeld 1234AA.",
          },
        },
      });

      el.setAttribute("novalidate", "");

      el.addEventListener("submit", (evt) => {
        evt.preventDefault();

        console.log('prevent submit');

        v.validate();
      });

      v.on("validation:success", () => {
        el.submit();

        console.log("validation success");
      });

      v.on('validation:start', (formEl) => {
        const inputFields = formEl.querySelectorAll('input[data-rules]:not([type="hidden"]):not([type="submit"]):not([type="button"]), select[data-rules], textarea[data-rules]') || [];

        inputFields.forEach(inputField => {
          inputField.removeAttribute('aria-invalid');
          inputField.removeAttribute('aria-describedby');
        });
      });

      v.on('field:error', (form, field, errors) => {
        const inputId = field.getAttribute('id') || '';
        const formGroup = field.closest('.form-group');
        const alertEl = formGroup ? formGroup.querySelector('.validator-err') : null;

        if (alertEl) {
          alertEl.setAttribute('id', `${inputId}-error`);
          field.setAttribute('aria-describedby', `${inputId}-error`);
        }

        field.setAttribute('aria-invalid', 'true');
      });

      v.on('validation:failed', (formEl) => {
        const inputFields = formEl.querySelectorAll('input[data-rules]:not([type="hidden"]):not([type="submit"]):not([type="button"]), select[data-rules], textarea[data-rules]') || [];
        let focusIsMoved = false;

        inputFields.forEach(inputField => {
          const inputId = inputField.getAttribute('id') || '';
          const formGroup = inputField.closest('.form-group');
          const alertEl = formGroup ? formGroup.querySelector('.validator-err') : null;

          if (!focusIsMoved && alertEl) {
            alertEl.setAttribute('id', `${inputId}-error`);
            inputField.setAttribute('aria-describedby', `${inputId}-error`);
            inputFields[0].focus();
          }

          focusIsMoved = true;
        });
      });
    });

    const updateCheckedState = (radioCheckboxItems, initialValidationRules, lastItemEl) => {
      const checkedItems = Array.from(radioCheckboxItems).filter(item => item.checked);

      if (lastItemEl && checkedItems.length) {
        lastItemEl.removeAttribute('data-rules');
      } else if(lastItemEl) {
        lastItemEl.setAttribute('data-rules', initialValidationRules);
      }
    }

    // FE validation isn’t working with a group of checkbox/radios:
    // https://github.com/upjs/facile-validator/issues/339
    requiredFormGroups.forEach((el) => {
      const radioCheckboxItems = el.querySelectorAll('input[type=radio], input[type=checkbox]');

      if (radioCheckboxItems.length > 1) {
        radioCheckboxItems.forEach(radioCheckboxEl => {
            const lastItemEl = radioCheckboxItems[radioCheckboxItems.length - 1];
            const initialValidationRules = lastItemEl.hasAttribute('data-rules') ? lastItemEl.getAttribute('data-rules') : '';

            radioCheckboxEl.addEventListener('change', () => {
              updateCheckedState(radioCheckboxItems, initialValidationRules, lastItemEl);
            });

            updateCheckedState(radioCheckboxItems, initialValidationRules, lastItemEl);
        });
      }
    });
  },
};
